import { render, staticRenderFns } from "./RuleEditionModal.vue?vue&type=template&id=0a1c6323&scoped=true&"
import script from "./RuleEditionModal.vue?vue&type=script&lang=js&"
export * from "./RuleEditionModal.vue?vue&type=script&lang=js&"
import style0 from "./RuleEditionModal.vue?vue&type=style&index=0&id=0a1c6323&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1c6323",
  null
  
)

export default component.exports